import BadgeStatus from '../../../../atoms/BadgeStatus';
import { TopologySubscription } from '../../../../../services/eventingApi';

const DeliveryIssueBadge = ({ subscription }: { subscription: TopologySubscription }) =>
  subscription.deliveryIssue ? <BadgeStatus color="orange" text={subscription.deliveryIssueFormatted ?? subscription.deliveryIssue} /> : null;

export default DeliveryIssueBadge;
